import script from "./FileBrowser.vue?vue&type=script&setup=true&lang=js"
export * from "./FileBrowser.vue?vue&type=script&setup=true&lang=js"

import "./FileBrowser.vue?vue&type=style&index=0&id=c1ef2866&scoped=true&lang=css"

import exportComponent from "../../../../DIARC/pixonanimation.az/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1ef2866"]])

export default __exports__